<script setup>
import Layout from "../../layouts/main.vue";
import UploadImage from "../../components/uploadImage.vue";
import { useRoute, useRouter } from "vue-router";
import { ref, onMounted, reactive, watch } from "vue";
import { FormInstance } from "element-plus";
import { useI18n } from "vue-i18n";
const { t } = useI18n();
import { langWeb } from "../../stores/lang";
const lang_web = langWeb();
const lang = ref(lang_web.showLang.toLocaleUpperCase());
import toastr from "toastr";
import mushroom from "cem-primary-api";
import MethodService from "../../service/MethodService";
import LanguageService from "../../service/LanguageService";
import Validate from "../../service/ValidService";
import { Filter } from "mushroomjs";

const ruleFormRef = ref(FormInstance);
const router = useRoute();
const routerPush = useRouter();
const propsIdAvatar = ref("");
const showErrorFormatEmail = ref(false);
const showErrorFormatPhoneNumber = ref(false);
const showErrorWithInputIsSpaceForAccount = ref(false);
const showErrorWithInputIsSpaceForName = ref(false);
const showErrorLengthPassword = ref(false);
const showCheckPassword = ref(false);
const groupArray = reactive({ value: [] }); // data quyền hạn sau khi gọi API về
let groupRef = ref([]); // mảng các id user_group --> sau chuyển vào component
let groupRefAPI = ref([]); // dùng để so sánh với groupRef
const dynamicRolesOptions = ref([]); // danh sách role động từ API
const selectedDynamicRoles = ref([]); // role động đã chọn
const loadingDynamicRoles = ref(true); // Trạng thái đang tải danh sách role động
const infoAccount = ref({
  id: "",
  account: "",
  roles: [],
  disabled: false,
});
const loadingBtn = ref(false);
const validateFlag = ref(false);
// dữ liệu form
let dataFormUser = reactive({
  value: {
    account: "",
    password: "",
    checkPass: "", // check nhập lại mật khẩu
    disabled: false,
    roles: router.name === "CapNhatTaiKhoan" ? [] : ["User"], // -> thêm mới tài khoản thì mặc định chọn user
    fullName: "",
    email: "",
    phone: "",
    avatarId: "",
    department: "",
    sub_department: "",
    position_id: "",
    account_type: "system", // system | ldap
    region_ids: [],
  },
});
let isReadOnly = ref(true);
const departmentArr = ref([]);
const positionArr = ref([]);
const sub_departmentArr = ref([]);
const showErrrorContent = ref(""); // hiển thị lỗi khi validate
const isQueryApiRole = ref(false);
const isTicketManagerRole = ref(false);
const isMonitorRole = ref(false);
const showMonitorConfigDialog = ref(false);
const monitorConfigRows = ref([]);
const monitorConfigLoading = ref(false);
const regionArr = ref([]);
// validate form
const validateAccount = (rule, value, callback) => {
  if (value === "") {
    callback(new Error(t("t-place-account")));
  } else {
    if (dataFormUser.value.password !== "") {
      if (!ruleFormRef.value) return;
      ruleFormRef.value.validateField("password", () => null);
    }
    callback();
  }
};
const validatePass = (rule, value, callback) => {
  if (value === "") {
    callback(new Error(t("t-please-input-password")));
  } else if (value && value.trim().length < 6) {
    callback(new Error(t("t_password_min_lenght")));
  } else if (
    dataFormUser.value.account?.length > 0 &&
    value.includes(dataFormUser.value.account)
  ) {
    callback(new Error(t("t_password_not_included_account")));
  } else {
    callback();
  }
};

const validatePassCheck = (rule, value, callback) => {
  if (value === "") {
    callback(new Error(t("t_error_re_enter_password")));
  } else if (value !== dataFormUser.value.password) {
    callback(new Error(t("t_password_not_match")));
  } else {
    callback();
  }
};
const rulesForm = reactive({
  account: [
    // Validate.required,
    { validator: validateAccount, trigger: "blur" },
    Validate.checkSpaceString,
    Validate.checkAccount,
    Validate.checkMaxLength(50),
  ],
  email: [Validate.required, Validate.checkEmail],

  password: [Validate.required, { validator: validatePass, trigger: "blur" }],
  checkPass: [
    { required: true, validator: validatePassCheck, trigger: "blur" },
  ],

  roles: [
    {
      trigger: "change",
      required: true,
      get message() {
        return (
          LanguageService?.lang?.t_please_choose_account_roles ??
          "t_please_choose_account_roles"
        );
      },
    },
  ],
  department: [
    {
      trigger: "change",
      required: true,
      get message() {
        return (
          LanguageService?.lang?.t_please_choose_department ??
          "t_please_choose_department"
        );
      },
    },
  ],
  fullName: [
    Validate.required,
    Validate.checkSpaceString,
    Validate.checkMaxLength(50),
  ],
  phone: [Validate.checkPhone10_11Number],
  account_type: [
    {
      trigger: "change",
      required: true,
      get message() {
        return t("t_please_choose_account_type");
      },
    },
  ],
});

const changeDepartment = (idDepartment) =>
  (dataFormUser.value.department = idDepartment);
const changeSubDepartment = (idSubDepartment) =>
  (dataFormUser.value.sub_department = idSubDepartment);
const changePosition = (idPosition) =>
  (dataFormUser.value.position_id = idPosition);

// check chiều dài mật khẩu
const checkLengthPassword = (password) => {
  showErrorLengthPassword.value = false;
  if (password.length < 6 && password.length > 0) {
    showErrorLengthPassword.value = true;
    showErrrorContent.value = t("t_error_min_password_length");
  } else if (password.includes(dataFormUser.value.account)) {
    showErrorLengthPassword.value = true;
    showErrrorContent.value = t("t_error_password_contain_account");
  } else {
    showErrorLengthPassword.value = false;
    showErrrorContent.value = "";
  }
  if (password.length > 0) {
    showCheckPassword.value = true;
  } else {
    showCheckPassword.value = false;
    dataFormUser.value.checkPass = "";
  }
};

// function thêm mới tài khoản
const fn_ThemMoiTaiKhoan = (formEl) => {
  loadingBtn.value = true;
  validateFlag.value = true;
  if (!formEl) return;

  formEl.validate(async (valid) => {
    if (valid) {
      // thông tin user thêm mới
      const newUser = {
        account: dataFormUser.value.account,
        password: dataFormUser.value.password,
        disabled: dataFormUser.value.disabled,
      };
      switch (dataFormUser.value.roles[0]) {
        case "Admin":
          newUser.roles = ["Admin", "User"];
          break;
        case "AdminPrimary":
          newUser.roles = ["AdminPrimary", "User"];
          break;
        case "AdminLocal":
          newUser.roles = ["AdminLocal", "User"];
          break;
        case "Edit":
          newUser.roles = ["Edit", "User"];
          break;
        case "NoneWebGUI":
          newUser.roles = ["NoneWebGUI"];
          break;
        default:
          newUser.roles = ["User"];
          break;
      }
      if (isQueryApiRole.value) newUser.roles.splice(1, 0, "QueryAPI");
      if (isTicketManagerRole.value)
        newUser.roles.splice(1, 0, "TicketManager");
      // thêm role động đã chọn
      if (selectedDynamicRoles.value.length > 0) {
        newUser.roles = [...newUser.roles, ...selectedDynamicRoles.value];
      }
      if (isMonitorRole.value) newUser.roles.splice(1, 0, "Monitor");
      // thông tin profile user thêm mới
      const newProfileUser = {
        fullname: dataFormUser.value.fullName.trim(),
        avatarId: dataFormUser.value.avatarId,
        email: dataFormUser.value.email,
        phoneNumber: dataFormUser.value.phone,
        permission: {
          is_editor: dataFormUser.value.roles[0] === "User" ? false : true,
        },
        department_id: dataFormUser.value.department,
        sub_department_id: dataFormUser.value.sub_department,
        position_id: dataFormUser.value.position_id,
        account_type: dataFormUser.value.account_type,
      };
      if (isMonitorRole.value) {
        newProfileUser.region_ids = dataFormUser.value.region_ids;
      }
      try {
        const res = await mushroom.user.createAsync(newUser);
        if (res.result) {
          newProfileUser.id = res.result;
          // thêm profile cho user vừa tạo thành công
          try {
            const id = await mushroom.profile.createAsync(newProfileUser);
            if (id.result) {
              // thêm quyền hạn cho user vừa tạo thành công
              groupRef.value.forEach(async (item) => {
                await mushroom.user_group.createAsync({
                  user_id: newProfileUser.id,
                  group_id: item,
                });
              });
              // Lưu cấu hình monitor nếu có
              if (isMonitorRole.value && monitorConfigRows.value.length > 0) {
                for (const row of monitorConfigRows.value) {
                  if (!row.region_id) continue;
                  const roles = [];
                  if (row.monitor_view) roles.push("MonitorView");
                  if (row.monitor_ack) roles.push("MonitorAck");
                  if (row.monitor_edit) roles.push("MonitorEdit");
                  try {
                    await mushroom.region_user.createAsync({
                      user_id: newProfileUser.id,
                      region_id: row.region_id,
                      roles: roles,
                    });
                  } catch (err) {
                    console.error("Lỗi tạo region_user: %o", err);
                  }
                }
              }
              setTimeout(() => {
                toastr.success(t("toastr_add_account_success"));
                routerPush.go(-1);
              }, 2000);
            }
          } catch (e) {
            MethodService.showError(e.code);
          }
        }
      } catch (error) {
        if (!MethodService.handlePasswordPolicyError(error, t)) {
          if (error?.meta?.field === "$unique_key") {
            toastr.error(t("toastr_account_existed"));
          }
        }
      } finally {
        setTimeout(() => {
          loadingBtn.value = false;
        }, 2000);
      }
    } else {
      loadingBtn.value = false;
      return false;
    }
  });
};

// function cập nhật tài khoản
const fn_CapNhatTaiKhoan = (formEl) => {
  loadingBtn.value = true;
  validateFlag.value = true;
  if (!formEl) return;

  if (
    !showErrorFormatEmail.value &&
    !showErrorFormatPhoneNumber.value &&
    !showErrorWithInputIsSpaceForAccount.value &&
    !showErrorWithInputIsSpaceForName.value &&
    !showErrorLengthPassword.value
  ) {
    formEl.validate(async (valid) => {
      if (valid) {
        // khai báo cập nhật user
        const updateUser = {
          id: router.params.id,
          disabled: dataFormUser.value.disabled,
        };

        const userRoles = dataFormUser.value.roles;

        if (userRoles.includes("AdminPrimary")) {
          updateUser.roles = ["AdminPrimary", "User"];
        } else if (userRoles.includes("Admin")) {
          updateUser.roles = ["Admin", "User"];
        } else if (userRoles.includes("AdminLocal")) {
          updateUser.roles = ["AdminLocal", "User"];
        } else if (userRoles.includes("Edit")) {
          updateUser.roles = ["Edit", "User"];
        } else if (userRoles.includes("NoneWebGUI")) {
          updateUser.roles = ["NoneWebGUI"];
        } else {
          updateUser.roles = ["User"];
        }

        if (isQueryApiRole.value) updateUser.roles.splice(1, 0, "QueryAPI");
        if (isTicketManagerRole.value)
          updateUser.roles.splice(1, 0, "TicketManager");
        // thêm role động đã chọn
        if (selectedDynamicRoles.value.length > 0) {
          updateUser.roles = [...updateUser.roles, ...selectedDynamicRoles.value];
        }
        if (isMonitorRole.value) updateUser.roles.splice(1, 0, "Monitor");

        if (
          dataFormUser.value.password &&
          dataFormUser.value.password.length > 0
        ) {
          updateUser.password = dataFormUser.value.password;
        }
        // khai báo cập nhật profile của user
        const updateProfileUser = {
          id: router.params.id,
          fullname: dataFormUser.value.fullName,
          avatarId: dataFormUser.value.avatarId,
          email: dataFormUser.value.email,
          phoneNumber: dataFormUser.value.phone,
          department_id: dataFormUser.value.department,
          sub_department_id: dataFormUser.value.sub_department,
          position_id: dataFormUser.value.position_id,
          account_type: dataFormUser.value.account_type,
        };
        if (isMonitorRole.value) {
          updateProfileUser.region_ids = dataFormUser.value.region_ids;
        } else {
          updateProfileUser.region_ids = [];
          // Xóa toàn bộ region_user khi bỏ quyền Monitor
          try {
            const regionUserRes = await mushroom.region_user.getAllAsync({
              filters: Filter.eq("user_id", router.params.id).build(),
            });
            if (regionUserRes.result && regionUserRes.result.length > 0) {
              for (const item of regionUserRes.result) {
                await mushroom.region_user.deleteAsync({ id: item.id });
              }
            }
          } catch (err) {
            console.error("Lỗi xóa region_user: %o", err);
          }
        }
        try {
          const newId = await mushroom.user.partialUpdateAsync(updateUser);
          // nếu cập nhật thành công user
          if (
            newId.result === infoAccount.value.id &&
            dataFormUser.value.disabled === true
          ) {
            toastr.error(t("t_account_not_login"));
            setTimeout(() => {
              let urlLogin = location.origin + "/login";
              window.location.replace(urlLogin);
            }, 2000);
          } else {
            if (newId.result === router.params.id) {
              // cập nhật profile cho user
              try {
                const response = await mushroom.profile.partialUpdateAsync(
                  updateProfileUser,
                );
                if (response.result === updateProfileUser.id) {
                  toastr.success(t("toastr_update_account_success"));
                  routerPush.push({ name: "DanhSachNguoiDung" });
                }
              } catch (e) {
                MethodService.showError(e.code);
              }
              // lấy danh sách group_id bị xóa
              let differenceRemove = groupRefAPI.value.filter(
                (x) => !groupRef.value.includes(x),
              );

              if (differenceRemove.length > 0) {
                differenceRemove.forEach(async (item) => {
                  try {
                    const response = await mushroom.user_group.getAllAsync({
                      filters: Filter.eq("group_id", item)
                        .eq("user_id", router.params.id)
                        .build(),
                    });
                    response.result.forEach(async (x) => {
                      try {
                        await mushroom.user_group.deleteAsync({
                          id: x.id,
                        });
                        await getUserGroup();
                      } catch (error) {
                        console.error("Có lỗi: %o", error);
                      }
                    });
                  } catch (e) {
                    console.error("Có lỗi: %o", e);
                  }
                });
              }

              let differenceAdd = groupRef.value.filter(
                (x) => !groupRefAPI.value.includes(x),
              );
              if (differenceAdd.length > 0) {
                differenceAdd.forEach(async (item) => {
                  try {
                    await mushroom.user_group.createAsync({
                      user_id: router.params.id,
                      group_id: item,
                    });
                    await getUserGroup();
                  } catch (error) {
                    console.error("Có lỗi: %o", error);
                  }
                });
              }
            }
          }
        } catch (error) {
          if (!MethodService.handlePasswordPolicyError(error, t)) {
            if (error?.meta?.field === "$unique_key") {
              toastr.error(t("toastr_account_existed"));
            } else if (error.code === 40002) {
              toastr.warning(t("toastr_disable_last_admin"));
            } else if (error.code === 40003) {
              toastr.warning(t("toastr_update_role_last_admin"));
            } else MethodService.showError(error.code);
          }
        } finally {
          setTimeout(() => {
            loadingBtn.value = false;
          }, 2000);
        }
      } else {
        loadingBtn.value = false;
        return false;
      }
    });
  } else loadingBtn.value = false;
};

// function lấy thông tin chi tiết của người dùng
const getUserInfo = async () => {
  try {
    const response = await mushroom.user.findByIdAsync({
      id: router.params.id,
      fields: "id,account,disabled,roles",
    });
    dataFormUser.value.account = response.result.account;
    dataFormUser.value.disabled = response.result.disabled;
    dataFormUser.value.roles = response.result.roles;
    isQueryApiRole.value = response.result.roles.includes("QueryAPI");
    isTicketManagerRole.value = response.result.roles.includes("TicketManager");
    isMonitorRole.value = response.result.roles.includes("Monitor");
  } catch (e) {
    MethodService.showError(e.code);
  }
};

// function lấy thông tin profile của người dùng
const getUserProfile = async () => {
  try {
    const response = await mushroom.profile.findByIdAsync({
      id: router.params.id,
      fields:
        "id,fullname,avatarId,email,phoneNumber,department_id,sub_department_id,position_id,account_type,region_ids",
    });
    dataFormUser.value.fullName = response.result?.fullname;
    dataFormUser.value.avatarId = response.result?.avatarId;
    dataFormUser.value.email = response.result?.email;
    dataFormUser.value.phone = response.result?.phoneNumber;
    dataFormUser.value.department = response.result?.department_id;
    dataFormUser.value.sub_department = response.result?.sub_department_id;
    dataFormUser.value.position_id = response.result?.position_id;
    dataFormUser.value.account_type = response.result?.account_type || "system";
    propsIdAvatar.value = response.result?.avatarId;
    if (response.result?.region_ids && response.result.region_ids.length > 0) {
      dataFormUser.value.region_ids = response.result.region_ids;
    }
  } catch (e) {
    MethodService.showError(e.code);
  }
};

// lấy về danh sách các quyền hạn --> sau cho vào pinia
const getGroup = async () => {
  try {
    const response = await mushroom.group.getAllAsync();
    groupArray.value = [];
    response.result.forEach((item) => {
      groupArray.value.push({
        value: item.id,
        label: item.name,
      });
    });
  } catch (e) {
    console.error("Có lỗi: %o", e);
  }
};

// lấy danh sách role động
const getDynamicRoles = async () => {
  loadingDynamicRoles.value = true;
  mushroom.user_role_dynamic.invalidCache();
  try {
    const response = await mushroom.user_role_dynamic.getAllAsync({
      fields: "id,name",
    });
    if (response.result) {
      dynamicRolesOptions.value = response.result.map((item) => ({
        value: item.name,
        label: item.name.startsWith("DYN_") ? item.name.substring(4) : item.name,
      }));
    }
  } catch (e) {
    console.error("Có lỗi: %o", e);
  } finally {
    loadingDynamicRoles.value = false;
  }
};

// lấy về quyền hạn theo user_id
const getUserGroup = async () => {
  mushroom.user_group.invalidCache();
  try {
    const response = await mushroom.user_group.getAllAsync(
      {
        filters: Filter.eq("user_id", router.params.id).build(),
      }
    );
    groupRef.value = [];
    groupRefAPI.value = [];
    response.result?.forEach((item) => {
      groupRef.value.push(item.group_id);
    });
    response.result?.forEach((item) => {
      groupRefAPI.value.push(item.group_id);
    });
  } catch (e) {
    console.error("Có lỗi: %o", e);
  }
};

const getIdImageUpload = (idImageUpload) => {
  dataFormUser.value.avatarId = idImageUpload;
};
const removeImageUpload = (data) => {
  propsIdAvatar.value = data;
  dataFormUser.value.avatarId = data;
};

const removeReadOnly = async () => {
  isReadOnly.value = false;
};

const departmentAPI = async () => {
  try {
    const response = await mushroom.department.getAllAsync();
    if (response.result) {
      response.result.forEach((element) => {
        departmentArr.value.push({
          value: element.id,
          label: element.name,
        });
      });
    }
  } catch (e) {
    console.error("Có lỗi: %o", e);
  }
};
const getPositionAPI = async () => {
  try {
    const response = await mushroom.position.getAllAsync();
    if (response.result) {
      response.result.forEach((element) => {
        positionArr.value.push({
          value: element.id,
          label: element.name,
        });
      });
    }
  } catch (e) {
    console.error("Có lỗi: %o", e);
  }
};
const subDepartmentAPI = async () => {
  try {
    const response = await mushroom.sub_department.getAllAsync();
    if (response.result) {
      response.result.forEach((element) => {
        sub_departmentArr.value.push({
          value: element.id,
          label: element.name,
        });
      });
    }
  } catch (e) {
    console.error("Có lỗi: %o", e);
  }
};

const fetchRegionArr = async () => {
  try {
    const response = await mushroom.region.getAllAsync();
    if (response.result) {
      regionArr.value = [];
      response.result.forEach((element) => {
        regionArr.value.push({
          value: element.id,
          label: element.name,
        });
      });
    }
  } catch (e) {
    console.error("Có lỗi: %o", e);
  }
};

const lowerCase = (event) => {
  dataFormUser.value.account = event.trim().toLowerCase();
};

const addMonitorConfigRow = () => {
  monitorConfigRows.value.push({
    region_id: "",
    monitor_view: false,
    monitor_ack: false,
    monitor_edit: false,
  });
};

const removeMonitorConfigRow = (index) => {
  monitorConfigRows.value.splice(index, 1);
};

const openMonitorConfigDialog = async () => {
  showMonitorConfigDialog.value = true;
  if (router.name === "CapNhatTaiKhoan" || router.name === "ChiTietTaiKhoan") {
    await fetchMonitorConfigRows();
  }
};

const fetchMonitorConfigRows = async () => {
  monitorConfigLoading.value = true;
  try {
    const response = await mushroom.region_user.getAllAsync({
      filters: Filter.eq("user_id", router.params.id).build(),
    });
    if (response.result && response.result.length > 0) {
      monitorConfigRows.value = response.result.map((item) => ({
        id: item.id,
        region_id: item.region_id,
        monitor_view: item.roles?.includes("MonitorView") || false,
        monitor_ack: item.roles?.includes("MonitorAck") || false,
        monitor_edit: item.roles?.includes("MonitorEdit") || false,
      }));
    } else {
      monitorConfigRows.value = [];
      addMonitorConfigRow();
    }
  } catch (e) {
    console.error("Lỗi lấy region_user: %o", e);
    monitorConfigRows.value = [];
    addMonitorConfigRow();
  } finally {
    monitorConfigLoading.value = false;
  }
};

const saveMonitorConfig = async () => {
  // Nếu danh sách trống thì xóa hết region_user cũ
  const validRows = monitorConfigRows.value.filter((row) => row.region_id);

  // Kiểm tra mỗi row đã chọn region phải có ít nhất 1 quyền
  const hasRowWithoutRole = validRows.some(
    (row) => !row.monitor_view && !row.monitor_ack && !row.monitor_edit,
  );
  if (hasRowWithoutRole) {
    toastr.warning(t("t_please_select_at_least_one_role"));
    return;
  }

  // kiểm tra trùng vùng miền
  const regionIds = validRows.map((row) => row.region_id);
  const hasDuplicate = regionIds.length !== new Set(regionIds).size;
  if (hasDuplicate) {
    toastr.warning(t("t_region_duplicate_warning"));
    return;
  }

  // thêm mới: chưa có userId → chỉ lưu tạm, đóng popup
  if (router.name === "ThemMoiTaiKhoan") {
    showMonitorConfigDialog.value = false;
    toastr.success(t("t_monitor_config_saved"));
    return;
  }

  // Form Cập nhật: có userId → gọi API lưu trực tiếp
  monitorConfigLoading.value = true;
  const userId = router.params.id;

  try {
    // Lấy danh sách region_user hiện tại để so sánh và xóa những cái không còn
    const currentRes = await mushroom.region_user.getAllAsync({
      filters: Filter.eq("user_id", userId).build(),
    });
    const currentItems = currentRes.result || [];

    // Xóa các region_user không còn trong danh sách mới
    const newRegionIds = validRows.map((row) => row.region_id);
    for (const item of currentItems) {
      if (!newRegionIds.includes(item.region_id)) {
        try {
          await mushroom.region_user.deleteAsync({ id: item.id });
        } catch (err) {
          console.error("Lỗi xóa region_user: %o", err);
        }
      }
    }

    // Tạo mới hoặc cập nhật
    for (const row of validRows) {
      const roles = [];
      if (row.monitor_view) roles.push("MonitorView");
      if (row.monitor_ack) roles.push("MonitorAck");
      if (row.monitor_edit) roles.push("MonitorEdit");

      try {
        await mushroom.region_user.createAsync({
          user_id: userId,
          region_id: row.region_id,
          roles: roles,
        });
      } catch (error) {
        // Nếu lỗi trùng thì update
        if (error?.meta?.field === "$unique_key") {
          const existingItem = currentItems.find(
            (item) => item.region_id === row.region_id,
          );
          if (existingItem) {
            await mushroom.region_user.partialUpdateAsync({
              id: existingItem.id,
              roles: roles,
            });
          }
        } else {
          console.error("Lỗi tạo region_user: %o", error);
        }
      }
    }
    toastr.success(t("t_monitor_config_saved"));
    showMonitorConfigDialog.value = false;
  } catch (e) {
    console.error("Lỗi lưu monitor config: %o", e);
    MethodService.showError(e.code);
  } finally {
    monitorConfigLoading.value = false;
  }
};

watch(
  () => lang_web.showLang,
  () => {
    lang.value = lang_web.showLang.toLocaleUpperCase();
    LanguageService.lang = LanguageService[lang.value];
    if (validateFlag.value)
      rulesForm.value = MethodService.copyObject(rulesForm);
  },
);



onMounted(async () => {
  let response = JSON.parse(localStorage.getItem("userInfo"));
  infoAccount.value = response.result;
  await departmentAPI();
  await getPositionAPI();
  await subDepartmentAPI();
  await fetchRegionArr();
  await getGroup();
  await getDynamicRoles();
  if (router.name === "CapNhatTaiKhoan" || router.name === "ChiTietTaiKhoan") {
    await getUserInfo();
    await getUserProfile();
    await getUserGroup();
    // Lấy các role động (DYN_*) từ roles của user
    selectedDynamicRoles.value = dataFormUser.value.roles.filter((role) =>
      role.startsWith("DYN_")
    );
  }
  let activeMenu = document
    .querySelector("#navbar-nav")
    .querySelector('[href="' + "/users/list-users" + '"]');
  activeMenu.classList.add("active");
});
</script>

<template>
  <Layout>
    <div class="card">
      <div
        class="card-header d-flex justify-content-between align-items-center"
      >
        <h3 v-if="router.name === 'ThemMoiTaiKhoan'" class="mb-0">
          {{ $t("t-add-user") }}
        </h3>
        <h3 v-if="router.name === 'ChiTietTaiKhoan'" class="mb-0">
          {{ t("t-user-details") }}
        </h3>
        <h3 v-if="router.name === 'CapNhatTaiKhoan'" class="mb-0">
          {{ $t("t-update-user") }}
        </h3>
      </div>
      <div class="card-body">
        <div class="main-body">
          <el-form
            ref="ruleFormRef"
            :model="dataFormUser.value"
            :rules="rulesForm"
            label-width="150px"
            class="form-user"
          >
            <b-row>
              <b-col md="6">
                <el-form-item :label="t('t_type_account')" prop="account_type">
                  <el-radio-group
                    v-model="dataFormUser.value.account_type"
                    :disabled="router.name == 'ChiTietTaiKhoan'"
                  >
                    <el-radio value="system">{{
                      t("t_type_account_system")
                    }}</el-radio>
                    <el-radio value="ldap">{{
                      t("t_type_account_ldap")
                    }}</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  :label="t('t-account')"
                  v-if="
                    router.name === 'CapNhatTaiKhoan' ||
                    router.name == 'ChiTietTaiKhoan'
                  "
                >
                  <el-input
                    type="text"
                    clearable
                    disabled
                    v-model="dataFormUser.value.account"
                  />
                </el-form-item>
                <el-form-item
                  :label="t('t-account')"
                  :prop="router.name === 'ThemMoiTaiKhoan' ? 'account' : ''"
                  v-else
                >
                  <el-input
                    type="text"
                    clearable
                    autocomplete="off"
                    :placeholder="t('t-login-account')"
                    :readonly="isReadOnly"
                    v-model="dataFormUser.value.account"
                    @click="removeReadOnly()"
                    @change="lowerCase"
                  />
                </el-form-item>
                <el-form-item
                  v-if="dataFormUser.value.account_type !== 'ldap'"
                  :label="t('t-password')"
                  :prop="router.name === 'ThemMoiTaiKhoan' ? 'password' : ''"
                >
                  <el-input
                    type="password"
                    autocomplete="off"
                    :disabled="router.name == 'ChiTietTaiKhoan'"
                    v-model="dataFormUser.value.password"
                    :readonly="isReadOnly"
                    @click="removeReadOnly()"
                    :placeholder="t('t-login-password')"
                    show-password
                    @change="checkLengthPassword(dataFormUser.value.password)"
                  />
                  <span
                    class="error-message"
                    v-if="
                      showErrorLengthPassword &&
                      router.name === 'CapNhatTaiKhoan'
                    "
                    >{{ showErrrorContent }}</span
                  >
                </el-form-item>
                <el-form-item
                  :label="t('t-enter-password-again')"
                  prop="checkPass"
                  v-if="
                    dataFormUser.value.account_type !== 'ldap' &&
                    showCheckPassword === true &&
                    router.name === 'CapNhatTaiKhoan'
                  "
                >
                  <el-input
                    type="password"
                    autocomplete="off"
                    v-model="dataFormUser.value.checkPass"
                    :placeholder="t('t-enter-password-again')"
                    show-password
                  />
                </el-form-item>
                <el-form-item :label="t('t-account-roles')" prop="roles">
                  <el-radio-group
                    v-model="dataFormUser.value.roles[0]"
                    :disabled="router.name == 'ChiTietTaiKhoan'"
                  >
                    <el-radio
                      label="Admin"
                      name="type"
                      v-show="infoAccount.roles.includes('Admin')"
                      >Super Admin</el-radio
                    >
                    <el-radio label="AdminPrimary" name="type">Admin</el-radio>
                    <el-radio label="AdminLocal" name="type"
                      >Admin Local</el-radio
                    >
                    <el-radio label="Edit" name="type">Edit</el-radio>
                    <el-radio label="User" name="type">View</el-radio>
                    <el-radio
                      label="NoneWebGUI"
                      name="type"
                      >{{$t('t_role_other')}}
                      <el-tooltip
                        effect="dark"
                        :content="$t('t_role_other_tooltip')"
                        placement="top"
                      >
                        <i class="ri-information-line" style="margin-left: 4px; cursor: pointer;"></i>
                      </el-tooltip>
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item>
                  <el-checkbox
                    :label="t('t_query_api')"
                    v-model="isQueryApiRole"
                    :disabled="router.name == 'ChiTietTaiKhoan'"
                  />
                  <el-checkbox
                    :label="t('t_ticket_manager')"
                    v-model="isTicketManagerRole"
                    :disabled="router.name == 'ChiTietTaiKhoan'"
                  />
                  <el-checkbox
                    :label="t('t_monitor_role')"
                    v-model="isMonitorRole"
                    :disabled="router.name == 'ChiTietTaiKhoan'"
                  />
                  <span
                    v-if="
                      isMonitorRole &&
                      (router.name === 'CapNhatTaiKhoan' ||
                        router.name === 'ChiTietTaiKhoan')
                    "
                    class="monitor-config-link"
                    @click="openMonitorConfigDialog"
                  >
                    <el-tooltip
                      class="box-item"
                      effect="dark"
                      :content="t('t_monitor_config')"
                      placement="top"
                    >
                      <i class="ri-settings-4-line"></i>
                    </el-tooltip>
                  </span>
                </el-form-item>

                <el-form-item
                  v-if="
                    router.name === 'CapNhatTaiKhoan' ||
                    router.name === 'ChiTietTaiKhoan'
                  "
                >
                  <el-checkbox
                    :disabled="router.name == 'ChiTietTaiKhoan'"
                    :label="t('t-lock-account')"
                    v-model="dataFormUser.value.disabled"
                    name="type"
                  />
                </el-form-item>
              </b-col>
              <b-col md="6">
                <b-row>
                  <b-col md="8">
                    <el-form-item :label="t('t_full_name')" prop="fullName">
                      <el-input
                        type="text"
                        clearable
                        :disabled="router.name == 'ChiTietTaiKhoan'"
                        autocomplete="off"
                        :placeholder="t('t-place-service-fullname')"
                        v-model="dataFormUser.value.fullName"
                        @change="
                          dataFormUser.value.fullName =
                            dataFormUser.value.fullName.trim()
                        "
                      />
                    </el-form-item>
                    <el-form-item label="Email" prop="email">
                      <el-input
                        type="text"
                        autocomplete="off"
                        :disabled="router.name == 'ChiTietTaiKhoan'"
                        v-model="dataFormUser.value.email"
                        placeholder="abc@gmail.com"
                      />
                    </el-form-item>
                    <el-form-item :label="$t('t-phone')" prop="phone">
                      <el-input
                        type="text"
                        autocomplete="off"
                        :disabled="router.name == 'ChiTietTaiKhoan'"
                        placeholder="0966867xxx"
                        v-model="dataFormUser.value.phone"
                      />
                    </el-form-item>
                    <el-form-item
                      :label="$t('t-departments')"
                      prop="department"
                    >
                      <el-select
                        filterable
                        :disabled="router.name == 'ChiTietTaiKhoan'"
                        v-model="dataFormUser.value.department"
                        :placeholder="$t('t-place-departments')"
                        :no-match-text="$t('t-match-data')"
                        :no-data-text="$t('t-no-data')"
                        @change="changeDepartment"
                        popper-class="custom-popper"
                      >
                        <el-option
                          v-for="item in departmentArr"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('t_sub_department')">
                      <el-select
                        filterable
                        :no-match-text="$t('t-match-data')"
                        :disabled="router.name == 'ChiTietTaiKhoan'"
                        v-model="dataFormUser.value.sub_department"
                        :placeholder="$t('t_select_sub_department')"
                        :no-data-text="$t('t-no-data')"
                        @change="changeSubDepartment"
                        clearable
                        popper-class="custom-popper"
                      >
                        <el-option
                          v-for="item in sub_departmentArr"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('t_position_name')">
                      <el-select
                        filterable
                        :no-match-text="$t('t-match-data')"
                        :disabled="router.name == 'ChiTietTaiKhoan'"
                        v-model="dataFormUser.value.position_id"
                        :placeholder="$t('t_select_position')"
                        :no-data-text="$t('t-no-data')"
                        @change="changePosition"
                        clearable
                        popper-class="custom-popper"
                      >
                        <el-option
                          v-for="item in positionArr"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col md="4">
                    <upload-image
                      :propsIdAvatar="propsIdAvatar"
                      @uploadImage="getIdImageUpload"
                      @removeImage="removeImageUpload"
                      :disabled="
                        router.name === 'ChiTietTaiKhoan' ? 'true' : 'false'
                      "
                    ></upload-image>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <!-- phân quyền người dùng -->
            <el-form-item :label="$t('t-group-roles')">
              <el-select
                filterable
                v-model="groupRef"
                multiple
                clearable
                :placeholder="$t('t-place-group-roles')"
                :disabled="router.name == 'ChiTietTaiKhoan'"
              >
                <el-option
                  v-for="item in groupArray.value"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>

            <!-- quyền truy cập động -->
            <el-form-item :label="$t('t_dynamic_access_roles')" v-if="!loadingDynamicRoles && dynamicRolesOptions.length > 0">
              <el-select
                filterable
                v-model="selectedDynamicRoles"
                multiple
                clearable
                :placeholder="$t('t_place_dynamic_access_roles')"
                :disabled="router.name == 'ChiTietTaiKhoan'"
              >
                <el-option
                  v-for="item in dynamicRolesOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>

            <div class="text-center">
              <button
                type="button"
                class="btn btn-soft-secondary btn-border mx-3"
                @click="routerPush.go(-1)"
              >
                {{ $t("t-back") }}
              </button>
              <el-button
                type="button"
                style="height: 40px"
                class="btn btn-secondary btn-border"
                @click="fn_ThemMoiTaiKhoan(ruleFormRef)"
                v-if="router.name === 'ThemMoiTaiKhoan'"
                :loading="loadingBtn"
              >
                {{ $t("t-add") }}
              </el-button>

              <el-button
                type="button"
                style="height: 40px"
                class="btn btn-secondary btn-border"
                @click="fn_CapNhatTaiKhoan(ruleFormRef)"
                v-if="router.name === 'CapNhatTaiKhoan'"
                :loading="loadingBtn"
              >
                {{ $t("t-update") }}
              </el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>

    <!-- Popup cấu hình Monitor -->
    <el-dialog
      v-model="showMonitorConfigDialog"
      :title="$t('t_monitor_configuration')"
      width="700px"
      :close-on-click-modal="false"
    >
      <template #header>
        <div class="monitor-dialog-header">
          <span class="monitor-dialog-title">{{
            $t("t_monitor_configuration")
          }}</span>
          <div class="monitor-dialog-actions">
            <el-button size="small" @click="addMonitorConfigRow">
              <i class="ri-add-line"></i> {{ $t("t-add") }}
            </el-button>
            <el-button
              size="small"
              type="primary"
              :loading="monitorConfigLoading"
              @click="saveMonitorConfig"
              :disabled="router.name == 'ChiTietTaiKhoan'"
            >
              <i class="ri-save-line"></i> {{ $t("t_save") }}
            </el-button>
          </div>
        </div>
      </template>

      <div v-loading="monitorConfigLoading" class="monitor-config-body">
        <div v-if="monitorConfigRows.length === 0" class="monitor-config-empty">
          {{ $t("t_monitor_no_permission_hint") }}
        </div>
        <div
          v-for="(row, index) in monitorConfigRows"
          :key="index"
          class="monitor-config-row"
        >
          <div class="monitor-config-row__region">
            <el-select
              v-model="row.region_id"
              filterable
              :placeholder="$t('t_select_region')"
              :disabled="router.name == 'ChiTietTaiKhoan'"
              :no-match-text="$t('t-match-data')"
              :no-data-text="$t('t-no-data')"
              style="width: 100%"
              popper-class="custom-popper"
            >
              <el-option
                v-for="item in regionArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
          <div class="monitor-config-row__roles">
            <el-checkbox
              v-model="row.monitor_view"
              :disabled="router.name == 'ChiTietTaiKhoan'"
              >View</el-checkbox
            >
            <el-checkbox
              v-model="row.monitor_ack"
              :disabled="router.name == 'ChiTietTaiKhoan'"
              >ACK</el-checkbox
            >
            <el-checkbox
              v-model="row.monitor_edit"
              :disabled="router.name == 'ChiTietTaiKhoan'"
              >Edit</el-checkbox
            >
          </div>
          <div class="monitor-config-row__action">
            <el-button
              type="danger"
              circle
              size="small"
              :disabled="router.name == 'ChiTietTaiKhoan'"
              @click="removeMonitorConfigRow(index)"
            >
              <i class="ri-delete-bin-line"></i>
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </Layout>
</template>
<link type="scss" src="./nguoidung.scss" />
